"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkSchemaProperties = exports.LinkSchema = void 0;
const zod_1 = require("zod");
const base_schema_1 = require("./base-schema");
const schema_properties_interface_1 = require("./schema-properties-interface");
exports.LinkSchema = base_schema_1.BaseSchema.extend({
    imageUrl: zod_1.z.string().optional(),
    link: zod_1.z.string().optional(),
    status: zod_1.z.enum(["shared", "deleted", "private"]),
    title: zod_1.z.string().optional(),
    url: zod_1.z.string().optional(),
});
exports.LinkSchemaProperties = {
    collectionName: "links",
    deleteMode: schema_properties_interface_1.DeleteMode.InStatus,
};
//# sourceMappingURL=link-schema.js.map